import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { VerificacionDocumentoComponent } from './docgest/_verificacion-documento/verificacion-documento.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { CanActivateViaAuthGuard } from './core/services/auth.guard';
import { TokenService } from './login/services/token.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { ChartModule } from 'primeng/chart';
import {HttpConfigInterceptor} from "./shared/httpconfig.interceptor";



@NgModule({
  declarations: [
    AppComponent,
    VerificacionDocumentoComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    ChartModule
  ],
  providers: [CanActivateViaAuthGuard, TokenService,{ provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
